import type { WorkspaceAction } from './workspacePermissions'
import { isViewerAction } from './workspacePermissions'

export interface CanActOnNodeParams {
  action: WorkspaceAction
  restricted: boolean
  uid?: string | null
  node?: { scopeRead?: string[]; scopeWrite?: string[] } | null
  isPathOnly?: boolean
}

/**
 * Pure helper for evaluating scoped access rights on a timeline element or checklist node.
 * Client and server agree on `scopeRead` and `scopeWrite` arrays.
 */
export const canActOnNode = ({
  action,
  restricted,
  uid,
  node,
  isPathOnly,
}: CanActOnNodeParams): boolean => {
  if (!restricted) return true
  if (isPathOnly) return false
  if (!uid || !node) return false

  if (isViewerAction(action)) {
    const hasRead = Array.isArray(node.scopeRead) && node.scopeRead.includes(uid)
    const hasWrite = Array.isArray(node.scopeWrite) && node.scopeWrite.includes(uid)
    return Boolean(hasRead || hasWrite)
  }

  return Boolean(Array.isArray(node.scopeWrite) && node.scopeWrite.includes(uid))
}
